export default __webpack_public_path__ + "static/media/add_circle.a54a5598.svg";